(function () {
  var unicoWrap = document.getElementById('UNICOunico');

  var mySwiper = new Swiper(".swiper-container", {
    speed: 1000,
    loop: true,
    effect: "slide",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  document.addEventListener('DOMContentLoaded',function(){
    scrollAnimation();
  });

  setTimeout(function(){
    topAnimation();
  },1200);

  function topAnimation() {
    var tops = unicoWrap.getElementsByClassName('mv');
    var top = Array.prototype.slice.call(tops)[0];
    var targets = top.getElementsByTagName('img');
    var target = Array.prototype.slice.call(targets);
    target.forEach(function(value) {
      value.classList.add('topfadeIn');
      setTimeout(function() {
        value.style.transform = 'translateY(0)';
        value.style.opacity = 1;
      }, 100);
    });
  }

  function scrollAnimation(){

    var ww = window.innerWidth;
    var wh = window.innerHeight;
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    var fadeins = document.getElementsByClassName('fadeIn');
    var fadein = Array.prototype.slice.call(fadeins);

    fadeinFunc();

    function fadeinFunc(){

      fadein.forEach(function(value,i){

        window.addEventListener('scroll',function(){

          var scroll = document.documentElement.scrollTop || document.body.scrollTop;
          var rect = value.getBoundingClientRect();
          var myTop = rect.top + window.pageYOffset;

          if(scroll > myTop -wh/1.2){
            value.style.transform = 'translateY(0px)';
            value.style.opacity = 1;
          }

        });

      });

    }

  }

  function rugItem(){

    var wrap = document.getElementById('rugUl');
    var blocks = wrap.getElementsByClassName('sizelist');
    var block = Array.prototype.slice.call(blocks);
    block.forEach(function(li){

      var imgDts = li.getElementsByClassName('itemImg');
      var imgDt = Array.prototype.slice.call(imgDts)[0];


      var chips = li.getElementsByClassName('chiplist');
      var chip = Array.prototype.slice.call(chips);

      chip.forEach(function(chipList){
        chipList.addEventListener('click',function(){

          var chipClasss = chipList.classList;
          var chipClass = Array.prototype.slice.call(chipClasss);
          var backImg = window.getComputedStyle(imgDt).backgroundImage;

          if(chipClass.indexOf('BGR')!= -1){
            if(backImg.includes('-OR') == true){
              var changeImg = backImg.replace('-OR','');
              imgDt.style.backgroundImage = changeImg;
            }
          }else if(chipClass.indexOf('OR')!= -1){
            if(backImg.includes('-OR') == false){
              var changeImg = backImg.replace('.png','-OR.png');
              imgDt.style.backgroundImage = changeImg;
            }
          }

        });
      });


    });


  }
})();
